export class ResetPasswordFakeDb {
  public static users = [];
}
